module.exports = __webpack_public_path__ + "img/tool-time.bc9a109.jpg";